<div class="dialog-header">
    <div class="ttm-image" app-svg-as-img [ttm]="data.ttm"></div>
    <h2 class="dialog-title">VKM #{{ data.ttm.id }}</h2>
    @if(selectedStatus() && currentStep() !== 1) {
        <app-status-chip [statusKey]="selectedStatus()?.key" [ttmStatuses]="statuses"></app-status-chip>
    }
    @for (field of availableWeightingFields; track field) {
        @if (fgWeightings.get(field)?.value) {
            <app-codalt-chip [text]="data.ttm.type[field + '_name']"></app-codalt-chip>
        }
    }
    <app-codalt-chip *ngIf="distance" [text]="(distance | number: '0.0-1') + 'm'" icon="location-dot" [error]="distance > 100">
        <i class="fa-solid fa-location-dot"></i>
    </app-codalt-chip>

    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    @if (currentStep() === 1) {
        <div class="step-header">Selecteer status</div>
        <div class="status-selection">
            @for (status of statuses | ttmStatus: data.ttm; track status.key) {
                <button mat-stroked-button (click)="selectStatus(status)" [class.selected]="fcStatus.value === status.key">
                    <i class="fa fa-circle" [style.color]="'#' + status.color"></i>
                    {{ status.name }}
                </button>
            }
        </div>
    }

    @if (currentStep() === 2) {
        <div class="step-header">{{ currentWeightingName() }}</div>
        <div class="weighting-selection">
            <button mat-flat-button type="button" color="warn" (click)="setWeightingValue(false)">Nee</button>
            <button mat-flat-button type="button" color="primary" (click)="setWeightingValue(true)">Ja</button>
        </div>
    }

    @if (currentStep() === 3) {
        <div class="step-header">Foto toevoegen</div>
        <div class="image-tiles">
            <div *ngIf="latestImage?.id" class="image-button" (click)="useLatest()" [class.loading]="loading === 'latest'" [style.order]="1">
                <div class="image">
                    <app-codalt-image url="ttm-images/image/{{ latestImage.id }}"></app-codalt-image>
                    <div class="overlay">
                        <span>Laatste foto</span>
                    </div>
                </div>
            </div>

            <div (click)="imageGallery.click()" class="image-button" [class.loading]="loading === 'gallery'" [style.order]="2">
                <i class="fa-solid fa-images"></i>
                <span>Galerij</span>
            </div>
            <div (click)="imageCamera.click()" class="image-button" [class.loading]="loading === 'camera'" *ngIf="Settings.isMobileDevice" [style.order]="4">
                <i class="fa fa-camera"></i>
                <span>Camera</span>
            </div>
            <div
                (click)="noPicture()"
                class="image-button light"
                [class.loading]="loading === 'none'"
                [style.order]="!latestImage && Settings.isMobileDevice ? 0 : 3"
            >
                <i class="fa fa-image-slash"></i>
                <span>Geen foto</span>
            </div>
        </div>
    }

    <div *ngIf="data.ttm.comment_show_on_status_change && data.ttm.comment" class="comment">
        <div class="title">Opmerking</div>
        <div [innerHTML]="data.ttm.comment | nl2br"></div>
    </div>
</div>
<input (change)="uploadFile($event)" type="file" id="imageCamera" name="imageCamera" accept="image/*" capture="environment" hidden #imageCamera />
<input (change)="uploadFile($event, true)" type="file" id="imageGallery" name="imageGallery" accept="image/*" hidden #imageGallery />
